<template>
    <div :class="quantityClass" class="font-weight-bold d-flex align-items-center justify-content-end text-nowrap">
        <span>{{ sign }} {{ formattedAbsValue }}</span>
    </div>
</template>

<script>
export default {
    name: "QuantityCell",
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        rawValue() {
            return this.row.IncomingQuantity || 0;
        },

        isInput() {
            return this.row.FuelTransactionType === 1 || this.row.FuelTransactionType === 6;
        },

        isBalance() {
            return this.row.FuelTransactionType === 5;
        },

        isPositiveAction() {
            if (this.isInput) return true;

            if (this.isBalance) return this.rawValue > 0;

            return false;
        },

        quantityClass() {
            return this.isPositiveAction ? "text-success" : "text-danger";
        },

        sign() {
            return this.isPositiveAction ? "+" : "-";
        },

        formattedAbsValue() {
            const absVal = Math.abs(this.rawValue);
            return absVal.toLocaleString("tr-TR", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 3,
            });
        },
    },
};
</script>
